import { post, get } from 'utils/api';
import { CategoryModelResponse } from './listCategory_services';

export type ProductRoutingModel = {
  stt: number;
  routingVersion?: string;
  productCode?: string;
  productName?: string;
  orderIndex?: number;
  stepCode?: string;
  stepName?: string;
  productionGuide?: string;
  estimateComplete?: number;
  ratedTime?: string;
  molds?: [string];
  productPerPage?: number;
};

export type ProductRoutingResponse = {
  data: Array<ProductRoutingModel>;
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
};

export type ImportExcelResponse = {
  message: string;
  isSuccess: boolean;
};

export interface IProductRoutingServices {
  getListProductRouting(data: any): Promise<ProductRoutingResponse>;
  importExcelProductRouting(formData: any): Promise<ImportExcelResponse>;
  getListProductCode(productCode?: string): Promise<CategoryModelResponse>;
  getListMolds(product?: string, isMold?: boolean): Promise<CategoryModelResponse>;
}

export function createProductRoutingServices(): IProductRoutingServices {
  return {
    getListProductRouting: async (data) => {
      return (await post(`MasterData/Product/get-list-product-routing`, data)).data;
    },
    importExcelProductRouting: async (formData) => {
      return (await post(`MasterData/Routing/import-excel-product-routing`, formData)).data;
    },
    getListProductCode: async (productCode) => {
      return (await get(`MasterData/Common/list-dropdown-product?${productCode && `ProductCode=${productCode}`}`)).data;
    },
    getListMolds: async (product, isMold) => {
      return (
        await get(
          `MasterData/Common/list-dropdown-product?${product && `ProductCode=${product}&`}${
            isMold && `IsMold=${isMold}`
          }`,
        )
      ).data;
    },
  };
}
